export default "__VITE_ASSET__C4qekDs7__"